export function isFileTooLarge(file: File, maxBytes: number): boolean {
  return file.size > maxBytes
}

export type UploadOutcome = 'success' | 'authExpired' | 'genericError'

export type UploadResultLike = { success: boolean; status?: number }

export function classifyUploadResult(result: UploadResultLike): UploadOutcome {
  if (result.success) return 'success'
  if (result.status === 401) return 'authExpired'
  return 'genericError'
}
